import { getIdentityProvider, IdentityProvider } from './cookie';
/** Hvilke personverninnstillinger bruker har på helsenorge */
export var Personverninnstilling;
(function (Personverninnstilling) {
    Personverninnstilling["SamtykkeDigitalHelsetjeneste"] = "fb640456-ae6f-4664-92c8-c6739d76caec";
    Personverninnstilling["SamtykkeJournalinnsyn"] = "dc5b5d14-deed-48e5-bf6d-99ed77f08a09";
    Personverninnstilling["SamtykkeRegisterinnsyn"] = "6ea1aa04-fad7-48c8-8432-1acb3fbf6d7b";
    Personverninnstilling["HarReservasjonAktivPaaHelsenorge"] = "805a8897-4af0-4f09-ae13-7a28ea6b6e45";
    Personverninnstilling["HarAktivtForeldreSamtykke"] = "f33b4f78-1614-4f7d-9a12-a0e398dbb84b";
    Personverninnstilling["HarInnsynssperre"] = "49770acc-2e1b-4a8c-ac88-6bf9d18bfbce";
})(Personverninnstilling || (Personverninnstilling = {}));
/**
 * Hent innbyggers personverninnstillinger
 * @returns Liste med guids fra HN.User.AktiveUtvalgtePersonverninnstillinger, eller tom liste
 */
export const getPersonverninnstillinger = () => {
    return window.HN?.User?.AktiveUtvalgtePersonverninnstillinger ?? [];
};
/**
 * Sjekk om bruker har personverninnstilling
 * @param guid Guid i HN.User.AktiveUtvalgtePersonverninnstillinger
 * @param personverninnstillinger Valgfri liste med personverninnstillinger. Hvis ikke oppgitt, hentes fra window.HN.User
 * @returns true dersom bruker har personverninnstilling
 */
export const hasPersonverninnstilling = (guid, personverninnstillinger) => {
    const list = personverninnstillinger ?? getPersonverninnstillinger();
    return list.includes(guid);
};
/**
 * Sjekk om bruker har innsynssperre
 * @param personverninnstillinger Valgfri liste med personverninnstillinger. Hvis ikke oppgitt, hentes fra window.HN.User
 * @returns true dersom bruker har innsynssperre
 */
export const getHarInnsynssperre = (personverninnstillinger) => {
    return hasPersonverninnstilling(Personverninnstilling.HarInnsynssperre, personverninnstillinger);
};
/**
 * Sjekk om bruker har reservasjon mot egen bruk av Helsenorge
 * @param personverninnstillinger Valgfri liste med personverninnstillinger. Hvis ikke oppgitt, hentes fra window.HN.User
 * @returns true dersom bruker har reservasjon mot egen bruk av Helsenorge
 */
export const getHarReservasjonAktivPaaHelsenorge = (personverninnstillinger) => {
    return hasPersonverninnstilling(Personverninnstilling.HarReservasjonAktivPaaHelsenorge, personverninnstillinger);
};
export var FullmaktType;
(function (FullmaktType) {
    FullmaktType[FullmaktType["OrdinaerFullmakt"] = 3] = "OrdinaerFullmakt";
    FullmaktType[FullmaktType["BekreftetFullmakt"] = 4] = "BekreftetFullmakt";
    FullmaktType[FullmaktType["UtenSamtykkekompenanseOver12"] = 7] = "UtenSamtykkekompenanseOver12";
})(FullmaktType || (FullmaktType = {}));
/**
 * Returnerer verdien satt på HN User LastLogOn
 */
export const getSistPalogget = () => {
    return window.HN?.User?.SistPalogget;
};
/**
 * Returnerer verdien satt på HN User Name
 */
export const getInnloggetFulltNavn = () => {
    return window.HN?.User?.InnloggetFulltNavn;
};
/**
 * Returnerer verdien satt på HN User FirstName
 */
export const getInnloggetFornavn = () => {
    return window.HN?.User?.InnloggetFornavn;
};
/**
 * Returnerer verdien satt på HN User RepresentertBruker
 */
export const getRepresentertBruker = () => {
    return window.HN?.User?.RepresentertBruker;
};
/**
 * Returnerer verdien satt på HN User HasRepresentation
 */
export const getHarRepresentasjon = () => {
    return window.HN?.User?.HarRepresentasjon;
};
/**
 * Returnerer verdien satt på HN User AmplitudeID
 */
export const getAmplitudeID = () => {
    return window.HN?.User?.AmplitudeID ?? undefined;
};
/**
 * Returnerer verdien satt på HN User VisPersonvelger
 */
export const getVisPersonvelger = () => {
    return window.HN?.User?.VisPersonvelger;
};
/**
 * Setter verdien til HN User VisPersonvelger
 */
export const setVisPersonvelger = (visPersonvelger) => {
    window.HN = window.HN || {};
    window.HN.User = window.HN.User || {};
    window.HN.User.VisPersonvelger = visPersonvelger;
};
/**
 * Returnerer verdien satt på HN User ErRepresentasjon
 */
export const getErRepresentasjon = () => {
    return window.HN?.User?.ErRepresentasjon;
};
/**
 * Returnerer true når innnbygger representerer en annen via fullmakt
 */
export const getErRepresentasjonViaFullmakt = () => getErRepresentasjon() === true && window.HN?.User?.FullmaktEgenskaper !== null;
/**
 * Returnerer true når innnbygger representerer en annen de har foreldreansvar for
 */
export const getErRepresentasjonMedForeldreansvar = () => getErRepresentasjon() === true && window.HN?.User?.ForeldreansvarEgenskaper !== null;
/**
 * Returnerer verdien satt på HN User ErMellom12Og16
 */
export const getErMellom12Og16 = () => {
    return window.HN?.User?.ErMellom12Og16;
};
/**
 * Bestemmer om bruker kan navigere vekk fra siden, uten å måtte bekrefte først
 */
export const getAllowNavigation = () => {
    return window.HN?.User?.AllowNavigation ?? false;
};
/**
 * Bestemmer om bruker kan navigere vekk fra siden, uten å måtte bekrefte først
 * @param value true dersom navigasjon skal være lov, false dersom bruker må bekrefte eventuelle endringer først
 */
export const setAllowNavigation = (value) => {
    window.HN = window.HN || {};
    window.HN.User = window.HN.User || {};
    window.HN.User.AllowNavigation = value;
};
/**
 * Returnerer true når FullmaktEgenskaper er analog og ordinær
 */
export const getErOrdinaerAnalogFullmakt = () => !!window.HN?.User?.FullmaktEgenskaper?.Analog && window.HN?.User?.FullmaktEgenskaper?.FullmaktType === FullmaktType.OrdinaerFullmakt;
/**
 * Returnerer true når FullmaktEgenskaper er analog og UtenSamtykkekompenanseOver12
 */
export const getErIkkeSamtykkeKompetentFullmakt = () => !!window.HN?.User?.FullmaktEgenskaper?.Analog &&
    window.HN?.User?.FullmaktEgenskaper?.FullmaktType === FullmaktType.UtenSamtykkekompenanseOver12;
/**
 * Returnerer true når bruker er logget inn via helsenorge-app
 */
export const getErInnloggetViaHnApp = () => getIdentityProvider() === IdentityProvider.HnApp;
/**
 * Returnerer true når bruker er logget inn via helsenorge-app for ungdom
 */
export const getErInnloggetViaHnAppUngdom = () => getIdentityProvider() === IdentityProvider.HnAppUngdom;
/**
 * Hent brukerens scopes
 * @returns Liste med scopes fra HN.User.Scopes, eller tom liste
 */
export const getScopes = () => {
    return window.HN?.User?.Scopes ?? [];
};
/**
 * Sjekk om bruker har scope
 * @param scope Navn på scope i HN.User.Scopes
 * @returns true dersom bruker har scope
 */
export const hasScope = (scope) => {
    return getScopes().includes(scope) ?? false;
};
